export const referenceImagesSelector = ({ referenceImages }) => referenceImages
